import { useRemoteConfig } from "@/hooks/remoteConfig/useRemoteConfig";

const useIsRakebackEnabled = () => {
  const { loading, value } = useRemoteConfig("enableRakebackUi");

  return { loading, isEnabled: value?.asBoolean() ?? false };
};

export { useIsRakebackEnabled };
